module.exports = __webpack_public_path__ + "static/media/cough1.e4a21b67.png";